// Deep links back to the live order on each platform.
//
// PROVISIONAL templates — confirm against a real order URL from each seller
// dashboard. Placeholders: {id} = platformOrderId, {id2} = platformOrderId2,
// {shop} = Shopify store handle. Returns '' when a link can't be built (e.g.
// Shopify with no store handle, or manual "direct" orders).

import { SOURCE } from '../constants';

// Shopify admin store handle (the "<handle>" in admin.shopify.com/store/<handle>).
export const SHOPIFY_SHOP = 'something-distinct';

export const ORDER_URL_TEMPLATES = {
  [SOURCE.ETSY]: 'https://www.etsy.com/your/orders/sold?order_id={id}', // confirmed
  [SOURCE.EBAY]: 'https://www.ebay.co.uk/sh/ord/details?orderid={id2}', // provisional
  [SOURCE.SHOPIFY]: 'https://admin.shopify.com/store/{shop}/orders/{id2}', // needs store handle
};

const fill = (tmpl, vals) =>
  tmpl.replace(/\{(\w+)\}/g, (_, k) => (vals[k] == null ? '' : String(vals[k])));

/** Build the platform order URL for an order, or '' if not available. */
export function buildOrderUrl(order, { shop = SHOPIFY_SHOP } = {}) {
  if (!order) return '';
  const tmpl = ORDER_URL_TEMPLATES[order.source];
  if (!tmpl) return ''; // direct / unknown
  if (order.source === SOURCE.SHOPIFY && !shop) return ''; // needs store handle
  const url = fill(tmpl, { id: order.platformOrderId, id2: order.platformOrderId2, shop });
  // Don't return a half-filled URL (missing the id it needs).
  return /\{|\/orders\/$|orderid=$|order_id=$|search_query=$/.test(url) ? '' : url;
}
